<script setup lang="ts">
import { Icon } from "@iconify/vue"

definePageMeta({
  layout: "changelog-entry",
})
const route = useRoute()
const { data } = await useAsyncData(route.path, () => {
  return queryCollection("changelog").path(route.path).first()
})
</script>

<template>
  <article v-if="data" class="prose mb-12">
    <h1><Icon icon="mdi:tag" class="mr-1" :inline="true" />{{ data.title }}</h1>
    <div class="mb-6">{{ data.date }}</div>
    <ContentRenderer :value="data" />
  </article>
</template>
